<div class="relative">
  <psc-hourly-manual-result
    *ngIf="isHourlyManual"
    [powerPlant]="powerPlant"
    [calculatorResultWrapper]="solarCalculatorResultWrapper">
  </psc-hourly-manual-result>

  <psc-hourly-tool-result
    *ngIf="solarCalculatorResultWrapper.consumptionInputMethod.toUpperCase() === ConsumptionType.HOURLY &&
      (solarCalculatorResultWrapper.productionType === ProductionType.PVSOL || solarCalculatorResultWrapper.productionType === ProductionType.PVSYS)"
    [powerPlant]="powerPlant"
    [calculatorResultWrapper]="solarCalculatorResultWrapper"></psc-hourly-tool-result>

  <psc-monthly-manual-result
    *ngIf="solarCalculatorResultWrapper.consumptionInputMethod.toUpperCase() === ConsumptionType.MONTHLY"
    [powerPlant]="powerPlant"
    [calculatorResultWrapper]="solarCalculatorResultWrapper"></psc-monthly-manual-result>


  <psc-recalculate
    *ngIf="showRecalculate"
    (recalculate)="recalculate($event)"
    [additionalData]="isHourlyManual"
    [solarCalculatorResult]="solarCalculatorResultWrapper.result"></psc-recalculate>

  <psc-annotations [taxIncluded]="false"></psc-annotations>

</div>
